//en文件
module.exports = {
  header1: "Home",
  header2: "About us",
  header2_1: "Who are we",
  header2_2: "Why choose us",
  header3: "Trading",
  header4: "MT5 Guide",
  header5: "Contact us",
  header6: "Open a real account",
  header7: "Login",
  header8: "Register",
  footer1: "Join the ranks of traders",
  footer2: "Free trial",
  footer3: "Start trading",
  footer4: "Follow us",
  footer5: "Copyright",
  footer6: "All rights reserved",
  home1: "Trading product",
  home2: "Deposit fee is free",
  home3: "as low as zero point difference",
  home4: "Trade can be done anywhere",
  home5: "More than 200 tradable products",
  home6: "9 time period options",
  home7: "You can log in to your account on Pc and Mobile",
  home8: "Professional analysis tools",
  home9: "Download MT5 for PC",
  home10: "Internet Trader",
  home11: "No need to download or install",
  home12: "Access your account on any web browser",
  home13: "As powerful as MT4",
  home14: "Connect to the market for transactions anytime, anywhere",
  home15: "Open the web version of mt5",
  home16: "Help you make it",
  home17: "Best trading decision",
  home18: "Use these trading tools to help you make the most informed decision",
  home19: "Intelligent Trading System",
  home20: "Get trading advantages through professional EA",
  home21: "Trading signal",
  home22: "As a beacon, it guides you to success. ",
  home23: "economic calendar",
  home24: "Master the latest market trends",
  home25: "Protrader tool",
  home26: "Get more trading opportunities",
  home27: "Market News",
  home28: "Selected market views",
  home29: "Analyst's View",
  home30: "Professional Economic Calendar",
  home31: "Open a trading account and deposit at least $1000",
  home32: "You can use a full set of professional trading tools",
  home33: "Instant Deposit",
  home34: "Open a real account",
  home35: "perfect experience",
  home36: "Extremely fast execution of trading orders",
  home37:
    '"What are the key elements when traders choose a foreign exchange broker?"-This is the question we keep asking ourselves when establishing {platform}. We believe that these elements are at the core of defining our values ​​so that we can meet customer needs and continue to provide excellent and reliable services. ',
  home38: "Account opening in 5 minutes",
  home39: "Combination of more than 200 tradable commodities",
  home40: "Fully functional account management system",
  home41: "Excellent market liquidity",
  home42: "Learn more",
  home43: "Compliance Supervision",
  home44: "Provide the best security",
  home45:
    "{platform} attaches great importance to supervision and safety. We provide all customers with a transparent and safe foreign exchange trading environment. ",
  home46: "Global Office",
  home47: "Multinational supervision",
  home48: "Cooperation with the world's top financial institutions",
  home49: "Funds Insurance",
  home50: "Supervision",
  home51: "Compensation",
  home52: "Insurance",
  home53: "Deposit method",
  home54: "market liquidity partner",
  home55:
    "{platform} cooperates with more than 14 world's top liquidity quotation providers, and sufficient liquidity can provide you with the best trading quotations in the market",
  home56: "Foreign exchange transactions",
  home57:
    "Taking advantage of the global economic turmoil to connect the world's most liquid financial market",
  home58: "Start trading immediately",
  home59: "Bulk commodity trading",
  home59_1: "Big deal",
  home60:
    "Choose gold, silver, crude oil or other soft commodities based on the main market trading cycle",
  home61: "Index Trading",
  home61_1: "Index",
  home62:
    "Trade through the fluctuations of the world's large stock indexes such as SP500, DJ30, FRA40 and DAX30",
  home63: "US/Hong Kong Stock Exchange",
  home64:
    "Master the trends of large global companies and trade US and Hong Kong stocks with CFDs",
  home65: "Contract for Difference",
  home66: "Global Business",
  home67:
    "It is our honor to provide customers with first-class and stable service",
  home68: "Web version transaction",
  who0: "Who is {platform}",
  who1: "Join the most innovative broker",
  who2:
    "{platform} has more than 10 years of experience and expertise in the global financial market and is committed to providing simple and transparent market access and helping customers achieve financial Target. ",
  who3:
    '{platform} Established in the UK in 2010, always adhering to the concept of "Enjoy trading anytime, anywhere", using advanced technical services to provide customers with excellent trading experience in the foreign exchange market, including original spreads and fast execution of accurate transactions ECN account and powerful client management system. ',
  who4: "Choose a trusted foreign exchange broker",
  who5:
    "{platform1} has always been committed to providing customers with an excellent trading environment, and has always insisted on exceeding the expectations of global financial regulators. We have learned in this industry that traders are eager to find a platform that they can trust. {platform2} Under the supervision of multiple institutions, we have accumulated more than 10,000 active customer trading accounts from all over the world, and they all rely on {platform3} to ensure the safety of their funds. ",
  who6: "Main regulatory agency",
  who7: "Global number",
  who8:
    "As one of the leaders in the global financial market, {platform} provides our customers with top-notch and stable services. ",
  who9: "The following are some relevant data of {platform}:",
  who10: "10 years+",
  who11: "Industry qualifications",
  who12: "1.5B or more",
  who13: "Monthly transaction volume",
  who14: "7M and above",
  who15: "Customer account",
  who16: "$1.5B",
  who17: "Monthly trading volume",
  why0: "Why choose {platform}",
  why1: "Not just a platform, but a partner",
  why2:
    '"What do traders want when choosing a foreign exchange broker?"-This is the question we kept asking ourselves when we founded {platform}. Believe that these elements are the core of our value, so that we can meet the needs of customers and continue to provide excellent and reliable services. ',
  why3:
    "The most important thing is that we want to build a brand that is well-known beyond price or product. We hope to become a brand for the new generation of transactions. Knowing the needs of our customers allows us to make changes more flexibly. We are a high-performance new-generation trading platform, {platform} is always by your side when you need it. ",
  why4: "We are by your side during the trading journey",
  why5:
    "Whether you are a novice or a veteran of many years of trading, our team will provide you with support at any time. Our platform is with you anytime, anywhere, our customer service team accompanies you every step you take, and we will accompany you to grow together. Although our competitors may be stronger than us, we have the drive for innovation and the support of a compliant trading platform. Understand why {platform} is your right choice:",
  why6: "Open real account immediately in 5 minutes",
  who6_1: "U.S. NFA regulation, registration ID: 0542569",
  why7: "Leverage up to 500:1",
  why8: "Can trade more than 200 kinds of commodities",
  why9: "Provide additional trading bonus",
  why10: "Powerful client management system",
  why11: "Excellent market liquidity",
  why12: "Multiple regulatory agencies and separate accounts as guarantee",
  trading1: "Use Metatrader5 platform",
  trading2: "Trade anytime, anywhere",
  trading3:
    "If you are a new customer of {platform}, just fill in the form at the top of this page, and you can use the MT5 trading platform within a few minutes. ",
  trading4:
    "If you are already a {platform} customer who is trading on the MT5 platform, you only need to log in to your customer management background, click to open your account and select MetaTrader5, you can seamlessly switch to MT5 and further enhance your trading experience. ",
  trading5:
    "MT5 mobile App allows you to connect to {platform} anytime, anywhere, and enjoy all-weather trading services. ",
  guide0: "MT5 Guide",
  guide1: "Download MT5 on your computer",
  guide3: "How to insert chart quota? ",
  guide3_0: "Follow the steps below:",
  guide3_1: "1) On the top menu column, choose to insert a quota. ",
  guide3_2: "2) You can also insert a quota from the navigation section. ",
  guide4: "How to avoid firewall protection? ",
  guide4_1:
    "Forbid your anti-virus firewall to apply for MetaTrader 4 and open port 1950. To apply for MetaTrader 5, open port 443. ",
  guide5: "How do I create trend lines and other research lines? ",
  guide5_1: '1) On the top menu column, select "Insert"',
  guide5_2: "2) Select the desired trend line. ",
  guide5_3:
    "3) After releasing the mouse button, an image icon of the selected trend line with a crosshair will appear. Use the mouse to place the crosshair on the selected chart. Click the mouse, hold down and move the mouse to adjust the size of the trend line. ",
  guide5_4:
    'The shortcut of the line research can also be quickly accessed by clicking the "Browse" tool to quickly access the line research, so that the icon just appears under the function list. ',
  guide5_5:
    "You can also choose other options that appear at the top of the screen. Including clicking on trend lines, crosshairs, Fibonacci retracement lines, etc. ",
  guide6: "How to display the bar graph? ",
  guide6_1:
    'In the menu bar at the top, select "Chart Bar Graph" or use the keyboard shortcut (Alt+1)',
  guide7:
    "How to get account information and daily transactions on Metatrader platform? ",
  guide7_1:
    "Please use the terminal (TERMINAL) part of the platform. If you do not open this section, you can browse through the terminal TERMINAL or use the keyboard shortcut Cntrl+t. ",
  guide7_2: 'In the terminal section, select "Account History Mark". ',
  guide7_3:
    "This mark shows you the history of your account, which can also be printed for your convenience. ",
  guide7_4: "Right click anywhere in this section. ",
  guide7_5:
    'Select "Save as report". (It can also be saved as an HTML file, which can be converted into an Excel file for recording.)',
  guide8: "How to display the candlestick chart? ",
  guide8_1:
    'On the top menu bar, select "Chart Candlestick Chart" or use the keyboard shortcut (Alt+2). ',
  guide9:
    "Can I use the MetaTrader application interface on your system? Can this be done on the mini/analog account first? ",
  guide9_1:
    "Yes, as long as you want, you can use the analog account first. Generally, specific terms and conditions apply to the access of the application interface to the real system. Make sure you discuss your project with an FXDD representative so they can help you. ",
  guide10: "How to display the line graph? ",
  guide10_1:
    'On the top menu bar, select "Chart and Line Graph" or use the keyboard shortcut (Alt+3). ',
  guide11: "How to zoom in or zoom out the chart? ",
  guide11_1: '1) Ensure that the "Chart" toolbar is enabled',
  guide11_2:
    "2) Next, select the icon of the reasonable action located under the function list, namely ‘+’ and ‘-’.’",
  guide11_3: "3) Select one of the two icons to zoom in or zoom out. ",
  guide11_4:
    "Or, use a keyboard shortcut for this function. To zoom in is (Shift +), and to zoom out is (-). ",
  guide12: "Does the MetaTrader platform help mini-lot (10K) trading? ",
  guide12_1:
    "Yes, you can use the MetaTrader platform to trade mini lots (10K). ",
  guide12_2:
    "The following is the range of lot sizes we use for trading on Metatrader:",
  guide12_3:
    "0.01 lot = 1000 organization's base currency (or US dollar) our 'super mini' lot. ",
  guide12_4:
    "0.10 lot = 10000 our 'mini' lot of the organization's base currency (or US dollar). ",
  guide12_5:
    "1.00 lot=100000 our 'standard' lot in the organization's base currency (or US dollar). ",
  guide13:
    "I have downloaded the platform. How to log in to my real account to trade? ",
  guide13_1:
    'The user should have received the e-mail notification of account approval. The login name and password are indicated on the notification (ie, the login name is "81234" and the password is "xxxxx"). This is the account information of your real account. If you downloaded the platform, open the login screen. Note that the screen that opens at this time will ask you to open an account. You can click "X" to exit this screen. ',
  guide13_2:
    'When logging in, select "File Login" and type in your login name and password. ',
  guide13_3:
    "The server field has a drop-down menu, select the following server: ‘FXDD-MT5 Live Server 2-FXDD’. ",
  guide13_4:
    'Listen to the "ding" sound (confirmation tone), your account will appear in the upper left corner of the platform. ',
  guide13_5:
    "If you see the price move in the Market Watch, and the terminal part displays the correct balance, it indicates that you have successfully logged in to your real account. If you have trouble logging in, please send an email to support@leedword.com. ",
  guide14: "How do I change my password on MetaTrader? ",
  guide14_1:
    'On the top menu bar, select "Tool Options" or keyboard shortcut (Ctrl+O). ',
  guide14_2: 'Under the "Server" icon, select "Edit". ',
  guide14_3:
    'Enter the current password in the "current password" text field. ',
  guide14_4: 'Check the "Modify Master Password". ',
  guide14_5: 'Enter the new password in the "New Password" text field. ',
  guide14_6: 'Retype the new password in the second "Confirm" text field. ',
  guide15: "How to choose a language? ",
  guide15_1:
    'On the top menu bar, select "Browse Language" and choose your preferred language. Then close the platform and restart the program. ',
  guide16:
    "To display different windows on the platform, what keyboard shortcuts can be used? ",
  guide16_1: "The most commonly used keyboard shortcuts are:",
  guide16_2: "Ctrl+M=Market price observation window",
  guide16_3: "Ctrl+N=Navigation window",
  guide16_4: "Ctrl+T=Terminal window",
  guide17: "How can I view all currency pairs provided by FXDD? ",
  guide17_1:
    'In the Market Watch window, right-click and select "Show All" to view all currency pairs that can be traded. All currency pairs are immediately visible. ',
  guide18: "How do I display high/low prices in the Market Watch window? ",
  guide18_1:
    "In the Market Watch window, follow the steps below to display high/low prices:",
  guide18_2: "Right click (any part) in the Market Watch window",
  guide18_3:
    'Select "High"/"Low". (At this time, the high and low prices of each currency pair of the day will appear.)',
  guide19: "Can you guide the creation of charts? What are the options? ",
  guide19_1:
    "Yes, the MetaTrader 5 platform is one of the most advanced platforms on the market, especially the graphics options and packages. ",
  guide19_2:
    'Use the "Help Topics" option under the Help menu (press F1) and mark the "Start working with the chart" section. This part should be the beginning of a good start. ',
  guide19_3:
    'You can change the overall appearance of the chart ("Function List"-"Chart"-"Content"). You can change the color of the background, foreground, table, etc. You can scroll the edge of the chart window to adjust the size of the chart, and pull down the mouse button to adjust the size. ',
  guide20: "How to modify the display time period of MetaTrader charts? ",
  guide20_1:
    'When adding a time limit to the main menu bar, select "Browse Toolbar". "Period" (if needed). Use the following legend to use the time limit in the chart:',
  guide20_2: "M1=1 minute chart",
  guide20_3: "M5=5 minutes chart",
  guide20_4: "M15=15-minute chart",
  guide20_5: "M30=30-minute chart",
  guide20_6: "H1=1 hour chart",
  guide20_7: "H4=4-hour chart",
  guide20_8: "D1=Daily chart",
  guide20_9: "W1=Weekly chart",
  guide20_10: "MN=Monthly Chart",
  guide21: "Is there a user guide for Metatrader 5.0? ",
  guide21_1:
    'Yes, select "Help Topics" on the platform or you can click here to download. Please note that we have an online seminar to help you understand the functions of this platform. If you want to participate in these online seminars, please send an email to the sales department. ',
  guide22:
    "What is the time zone on the Metatrader platform? Can this time be adjusted? ",
  guide22_1:
    "Daylight saving time, the customer's time on MetaTrader is GMT+3 (Greenwich Mean Time plus 3 hours, Beijing Time plus 5 hours). Unfortunately, the time on the MetaTrader platform cannot be changed. We are deeply sorry for any inconvenience caused. ",
  guide23: "How to open another analog account on the MetaTrader platform? ",
  guide23_1: 'Select "File to open an account" in the platform',
  guide23_2:
    'Fill in the required information (be sure to tick the "I agree to subscribe to your newsletter" column)',
  guide23_3: 'Select "Next" (on the server page)',
  guide23_4:
    'Choose "Next" (Please note that your username and password will appear)',
  guide23_5: 'Select "Finish"',
  guide23_6:
    "This software will automatically log you in to your new analog account and check it in the navigation window. ",
  guide24:
    "What are the factors that affect the amount of communication in the program? ",
  guide24_1:
    "The amount of output communication depends on the user's activity, and the amount is quite small. The amount of communication entered directly depends on the number of open chart windows. ",
  guide25: "Can I receive warnings via email? ",
  guide25_1: "Follow the steps below to create an email alert in MetaTrader 5:",
  guide25_2:
    '(All Simple Mail Transfer Protocol (SMTP) settings vary by Internet service provider. If you receive an error message, contact your Internet service provider’s technical support and ask them to implement the Simple Mail Transfer Protocol If you use Outlook, you can select "Cancel when the tool email account is modified in the next step" to set the simple mail transfer protocol. ',
  guide25_3: 'Select "Tool Options". ',
  guide25_4: 'Select the "email" icon. ',
  guide25_5:
    "Edit the above settings according to your internet service provider's requirements. Usually, the light red text is the general rule that you should log in. For specific instructions, please contact your Internet service provider. (Note: Internet email services that cannot be used include Hotmail, Yahoo, Gmail, etc.)",
  guide25_6:
    "Simple Mail Transfer Protocol Server-This is the mail server address of your Internet service provider",
  contact1: "When you need us, we are always by your side",
  contact2:
    "If you have any questions or need more assistance, please contact us through the following contact information. We will try our best to answer all questions as soon as possible. ",
  contact3: "Registered address",
  contact4: "Cayman Office",
  contact5: "Office",
  contact6: "No. 7, Section 5, Xinyi District, Taipei, Taiwan (Taipei 101)",
  contact7: "Email address",
  contact8: "Phone",
  address1: "Sydney, Australia",
  address2: "Taipei",
  address3: "Bangkok, Thailand",
  address4: "Kuala Lumpur, Malaysia",
  address5: "London, England",
  address6: "United States, New York",
  address7: "Singapore, Singapore",
  address8: "George Town, Cayman Islands",
  address9: "Nicosia, Cyprus",
  address10: "Hong Kong",
  address11: "Hanoi, Vietnam",
  address12: "Melbourne, Australia"
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js